export default {
  // 导航栏
  nav: {
    home: '主页',
    practice: '实务',
    comprehensive: '综合',
    donate: '打赏',
    readMe: '必读',
    translationTool: 'Agentic Translation Studio',
    translationServices: '笔译服务',
    apiTutorial: 'API及使用教程',
    terminologyTool: '术语库工具',
    wordCountTool: '字数统计工具',
    wordFrequencyTool: '词频统计工具',
    corpusAlignmentTool: '语料对齐工具',
    otherTools: '其它工具',
    studyTools: '英专备考福利工具',
    cattiPractice: 'CATTI实务系统',
    featureNotOpen: '功能暂未开放',
    cattiComprehensive: 'CATTI综合系统',
  },

  // 主页
  landing: {
    title: 'O-max',
    subtitle: 'Studio',
    tagline: '不止于翻译，更在重塑翻译行业',
    enterSite: '点击进入',
    intro: 'O-max Studio，深耕前沿翻译技术，不止于翻译，更在重塑翻译行业。O源自Omni，意为全能，核心是搭建全场景翻译体系，支持任意可提取文本的翻译，覆盖215种语言双向互译，一站式处理视频、音频、图片、文档等各类素材。Max代表极致，致力于在翻译质量与工作效率上实现全方位突破。这套系统赋予AI贴近人类译者的翻译思维，运用各类翻译策略、方法与技巧，自动化完成译文撰写、润色、自检和修正。',
    agentTitle: '定价',
    enterpriseTitle: '伙伴计划',
    partnerLifetime: '尊享会员',
    partnerIndividual: '独立译者',
    partnerAcademic: '高校师生',
    partnerLimitedTime: '限时',
    partnerEnterprise: '企业战略合作',
    partnerContact: '联系客服',
    translationPricing: '翻译软件定价',
    businessCooperation: '商务合作',
    technicalSupport: '技术支持',
    officialAccount: '公众号',
    officialAccountName: '元译科技',
    // 导航栏
    navMetaTranslate: '团队介绍',
    navAIFAQ: 'AI问答',
    navTranslationSoftware: '翻译软件',
    navToolsAndPricing: '工具下载及价格',
    // AI快问快答区域
    aiFAQTitle: 'AI知识快问快答',
    faq1Question: 'API Key 和 Token 分别是什么？',
    faq1Answer: '可以把它们比作“运营商”和“手机卡”。API Key 就像运营商给你的“接入凭证”，决定了你能连到哪家 AI 服务；Token 则像手机卡里的“流量套餐”，AI 每次思考、生成内容都要消耗 Token，用完了就需要继续充值。简单说：API Key 负责“能不能接上”，Token 负责“还能用多少”。',
    faq2Question: '为什么软件需要配置 API Key 和充值 Token 才能用？',
    faq2Answer: '软件就像手机，本身负责把文档、术语和指令整理好，但翻译、润色、审校这些 AI 能力需要联网调用服务。API Key 相当于让软件接上 AI 服务，Token 相当于可用额度；两者都有，软件才能把请求发给 AI，再把结果带回来。',
    faq3Question: 'AI 翻译为什么一个字一个字蹦出来？',
    faq3Answer: '这是“流式输出”的表现。AI 其实已经想好了整段内容，但为了让你更快看到结果，也避免有人恶意刷接口，会把答案一小段一小段地推送出来，所以看起来像“一个字一个字地蹦”。',
    faq4Question: '配置均已正确，为何调用 AI 翻译、润色等功能偶尔会失败？',
    faq4Answer: '通常不是配置本身的问题，而是外部服务在波动：网络不稳定、模型侧临时拥堵、额度耗尽或 Key 被限流，都可能导致调用失败。可以先重试一次，仍然失败就换一个模型，或稍后再试。',
    faq5Question: 'AI 翻译和普通机器翻译区别在哪？',
    faq5Answer: '普通机器翻译靠词对词、句对句的规则匹配，速度快但读起来生硬；AI 翻译基于大语言模型，会结合上下文理解语义和语气，术语前后更一致，译文更自然，更适合专业文档。',
    faq6Question: '为什么要用 API Key？直接用网页不行吗？',
    faq6Answer: '网页版是公共入口，有使用次数和输入长度限制，也不能批量处理文档；API Key 是专属通道，可以批量调用、自己调参数、接入自己的工作流程，更适合专业场景。',
    faq7Question: '为什么 API Key 要花钱，网页却免费？',
    faq7Answer: '网页版免费，是因为限制了使用次数和时长，成本可控；API Key 按用量计费，调用量大、并发高，需要承担对应的算力成本。',
    faq8Question: '官方 AI 和第三方代理有什么不同？',
    faq8Answer: '官方由服务提供方自己运营，价格透明、响应快、稳定性好；第三方代理往往价格更低，但可能存在限速、断供或数据安全风险，重要项目建议优先使用官方渠道。',
    faq9Question: '能在自己电脑上装 AI 软件吗？',
    faq9Answer: '可以，但对硬件要求较高，需要足够的显存和内存。普通办公电脑只能跑参数很小的模型，效果会打折扣；多数场景下，用 API Key 调用云端服务更省心。',
    faq10Question: '什么是 AI 率？',
    faq10Answer: 'AI 率是衡量一段文本“由 AI 生成的可能性”的比例参考。检测工具通过用词习惯、句式结构和表达规律给出判断，但它只是概率参考，不能作为判定是否使用 AI 的绝对依据，存在误判的可能。',
    faq11Question: '什么是 AI 痕迹？',
    faq11Answer: 'AI 痕迹指文本里容易被人或检测工具判断为“机器生成”的特征，常见的有：\n· 句式过于工整对称，缺少自然变化\n· 用词偏书面化、模板化，比如“首先 / 其次 / 最后”“综上所述”\n· 段落结构高度一致，看不出个人表达习惯\n· 内容空泛，缺少具体细节和真实经验',
    faq12Question: '使用 AI 生成内容时，该如何规避明显的 AI 痕迹？',
    faq12Answer: '可以从这几点入手：\n· 生成后人工改写，调整句式和语序，让表达更贴合自己的习惯\n· 替换模板化表达，补充具体案例、数据和细节\n· 打散过于工整的段落结构\n· 结合自身经验加入个性化内容\n· 重要文本做人工审校，确保事实准确、逻辑通顺',
    faq13Question: '我到底能不能用 AI？我担心存在使用风险。',
    faq13Answer: '关键看用途和规范：\n· 用于辅助理解、生成初稿、整理资料，通常是安全且高效的\n· 正式提交的作业、论文、报告，要遵守所在机构的规定，按要求标注或限制使用范围\n· 涉密、敏感内容不要上传到公开的 AI 服务\n· 建议“AI 生成 + 人工把关”，既提效也不失责任',
    faq14Question: '做翻译时可以做译后编辑吗？译后编辑会不会被检测出来？',
    faq14Answer: '译后编辑是行业常规做法，机器翻译加人工润色本身就是标准流程，不存在“违规”的问题。会不会被检测出来，取决于交付方对 AI 使用的具体要求：如果明确要求全人工翻译，应事先沟通确认；如果没有特别限制，译后编辑能在保证质量的同时提升效率。',
    // 翻译软件区域
    translationSoftwareTitle: '创新要点',
    innovationFeatures: {
      feature1: '全面接入主流AI及机器引擎',
      feature2: 'PDF独家算法，更好排版及译文',
      feature3: '支持导入mdx等格式词典',
      feature4: '图像文档重构，还原原始图片内容与排版信息',
      feature5: '数据库接入，复用翻译资产',
      feature6: '翻译及思维工作流',
      feature7: '更多支持请详见"Agentic Translation Studio"'
    },
    // 工具及价格区域
    toolsAndPricingTitle: '工具下载及价格',
    corpusAlignmentTool: '语料对齐工具',
    terminologyCreationTool: '术语库创建工具',
    wordCountingTool: '字数统计工具',
    wordSegmentationTool: '分词统计工具',
    cattiPracticeSystem: 'CATTI 实务系统',
    cattiComprehensiveSystem: 'CATTI 综合系统',
    // 价格相关
    pricingTitle: '统一价格体系',
    pricingSubtitle: '所有工具采用统一定价，简单透明',
    pricingNote: '* 一机一码绑定，不支持取消授权',
    free: '免费',
    internalInterns: '内部实习生使用',
    // 工具列表
    availableTools: '可用工具列表',
    // 下载链接
    downloadLinks: '下载链接',
    baiduNetdisk: '百度网盘',
    quarkNetdisk: '夸克网盘',
    teraboxNetdisk: '小飞机网盘（推荐）',
    // 微信联系
    wechatContact: '微信联系',
    wechatContactHint: '扫码添加客服微信',
    scanQRCode: '扫码添加微信',
    wechatDescription: '扫描二维码，添加客服微信，获取更多产品信息和优惠活动'
  },

  // 工具页面通用
  toolPage: {
    features: '功能特性',
    demonstration: '功能演示',
    visualDemo: '直观展示 · 操作演示 · 一目了然',
    simpleOperation: '操作简单 · 功能强大 · 效率提升',
    fastImport: '快速导入 · 精准统计 · 便捷导出',
    intelligentSegmentation: '智能分词 · 精准搜索 · 高效统计',
    targetUsers: '适合人群'
  },

  // 通用「适合人群」（用于没有单独文案的工具）
  commonTool: {
    targetUsers: {
      title: '适合人群',
      subtitle: '适用于多种专业场景的实用工具',
      feature1: {
        title: '学术研究人员',
        content: '需要处理大量文档、进行数据分析和内容整理的专业人士'
      },
      feature2: {
        title: '内容创作者',
        content: '包括编辑、记者、文案等需要高效处理文字工作的从业者'
      },
      feature3: {
        title: '语言学习者',
        content: '学习语言过程中需要分析文本结构和词汇分布的学习者'
      },
      feature4: {
        title: '数据分析师',
        content: '需要从文本中提取关键信息和统计数据的专业人员'
      }
    }
  },

  // 翻译工具
  translationTool: {
    title: '超强翻译工具',
    subtitle: '专业翻译工具 · 智能AI辅助 · 极致体验',
    // 序号不写在文案里：展示顺序由 ToolPageLayout 的 TRANSLATION_FEATURES 决定，
    // 卡片上的编号由组件按顺序生成，增删条目不用再回来改标题。
    feature1: {
      title: '多语言支持',
      content: '支持 200 多种语言互译（汉语、英语、俄语、日语、韩语、法语、西班牙语、泰语、印度尼西亚语、荷兰语等），并可继续扩展语种'
    },
    feature2: {
      title: '多格式支持',
      content: '支持文档（docx、pptx、xlsx、PDF）、视频与字幕（ass、srt）、网页（HTML）、设计与工程文件（InDesign、Photoshop、Illustrator、DWG、DXF）、翻译交换格式（xliff、sdlxliff）等，并可继续扩展格式'
    },
    feature3: {
      title: '导出功能',
      content: '支持"原文、译文、双语左右对照、双语上下对照"多种导出格式'
    },
    feature4: {
      title: '匹配翻译功能',
      content: '支持"语料库（excel文档及sdlxliff格式文档）"导入匹配翻译，自动匹配原文及译文'
    },
    feature5: {
      title: '交互体验',
      content1: '界面简洁美观，操作简单（打开程序→拖拽导入文档→"机器翻译"下拉菜单的免费翻译）',
      content2: '启动迅速，程序体积一直控制在很小的量级，老机器也带得动，随装随用'
    },
    feature6: {
      title: 'AI特色（聊天、翻译、润色、审校、术语提取、思维导图、总结全文）',
      content1: '支持云端大语言模型（兼容OpenAI格式），上下文比Trados插件更长',
      content2: '支持本地大语言模型（兼容Ollama格式），断网可用，适合涉密单位数据安全'
    },
    feature7: {
      title: '自定义拼写检查及术语规范检查',
      content1: '支持对译文单元格待审校译文的标注',
      content2: '等等'
    },
    feature8: {
      title: '文档管理功能',
      content: '支持文档管理、搜索功能，快速定位和管理翻译项目'
    },
    feature9: {
      title: '日历功能',
      content: '支持日历功能，译文交付日期一目了然，项目管理更加高效'
    },
    feature10: {
      title: '文档分发功能',
      content: '支持文档及数据分发，便于团队协作，提升项目整体效率'
    },
    feature11: {
      title: '术语干预与检测功能',
      content: '支持术语干预，可自定义设置违规词检测等，确保翻译质量和合规性'
    },
    feature12: {
      title: '笔记功能',
      content: '支持文档笔记、全局笔记，高效学习工作，让翻译更加便捷高效'
    },
    feature13: {
      title: '术语库创建功能',
      content: '支持术语库创建，快速收集导出文档术语，专业术语管理更加高效'
    },
    feature14: {
      title: '自定义背景图片及皮肤颜色管理',
      content: '支持自定义背景图片和皮肤颜色，打造个性化工作界面，提升使用体验'
    },
    feature15: {
      title: '更多功能等您探索',
      content: '持续更新迭代，为您带来更多实用功能，敬请期待...'
    },
    feature16: {
      title: '工作流与后台批处理',
      content1: '把"预翻译 → 润色 → 审校 → 导出"编排成一条工作流，文档交给后台自动跑完，中途无需盯着',
      content2: '多个文档可同时排队处理，处理期间界面照常使用，长文档不再占着人干等'
    },
    feature17: {
      title: 'LLM 幻觉检测与痕迹修订',
      content1: '逐句比对原文与译文，自动标出大模型的漏译、增译、数字与专有名词错译等幻觉内容',
      content2: 'AI 的每一处改动都以修订痕迹呈现，可逐条查看、接受或回退，改了什么一目了然'
    },
    feature18: {
      title: '翻译记忆库查询调用',
      content1: '翻译过程中可随时查询记忆库，命中的句段一键回填到当前单元格，无需切出去手动检索',
      content2: '定稿句段实时入库，与当前文档无缝衔接，越译越快、越译越一致'
    },
    feature20: {
      title: '机器翻译',
      content1: '内置多家云端机器翻译引擎，文档拖进来即可一键预翻译全文，开箱免费可用',
      content2: '同时支持本地离线引擎，断网也能翻，涉密资料不出内网'
    },
    feature19: {
      title: '对话式译文精修',
      content1: '选中任意翻译单元格，用一句话说清怎么改（更简洁、更正式、换个术语），模型即时重写该句',
      content2: '同一条指令可批量套用到整篇译文，全文风格与术语一次拉齐'
    },
    // 适合人群：由 ToolPageLayout 单独排一屏，侧边导航里有独立入口
    targetUsers: {
      title: '适合人群',
      subtitle: '不同场景 · 各取所需',
      feature1: {
        title: '科研文献阅读者',
        content: '科研 PDF 直接打开双语对照阅读，公式、上下标、图表编号原样保留不乱码——这项功能完全免费。'
      },
      feature2: {
        title: '外贸从业者',
        content: '技术文档、双语报价单一键翻译，原文排版照原样保留，拿到手就能直接发出去。'
      },
      feature3: {
        title: 'MTI 高校学生',
        content: '实践报告要的"双语左右对照"一键导出，术语和语料顺手沉淀下来，课程作业与毕业材料一起解决。'
      },
      feature4: {
        title: '视频翻译',
        content: '支持可视化字幕编辑校对功能，译者可对照视频校验字幕、调整字幕时长，并实时预览单语及双语字幕效果，同时支持快速导出。'
      }
    }
  },
  wordCountTool: {
    title: '字数统计工具',
    subtitle: '精准统计 · 批量处理 · 安全高效',
    feature1: {
      title: '多种文档格式支持',
      content: '全面支持主流文档格式，包括 Word 文档、Excel 表格、PowerPoint 演示文稿以及纯文本文件。'
    },
    feature2: {
      title: '精准文字统计',
      content: '统计中文、英文、日文、韩文、俄文、法文、西班牙文，智能区分标点符号，精确计算文档页数和文件大小，确保统计结果准确可靠。'
    },
    feature3: {
      title: '批量处理功能',
      content: '支持文件夹批量导入，一键处理多个文档，支持拖拽文件操作，树形结构展示结果，让您的工作高效便捷，层次清晰一目了然。'
    },
    feature4: {
      title: '数据安全与管理',
      content: '本地处理数据，安全存储，无信息泄露风险。支持一键导出 Excel 表格，让文档信息整理更加方便快捷。'
    },
    feature5: {
      title: '广泛应用场景',
      content: '适用于多种专业场景：学术研究（快速统计论文字数，满足投稿要求）、出版编辑（精确计算稿件篇幅）、翻译工作（准确统计原译文字数，便于计费）、内容审核（批量处理文档）、文档管理（整理归档文件信息）。'
    }
  },

  // 词频统计工具
  wordFrequencyTool: {
    title: '词频统计工具',
    subtitle: '智能分词 · 快速统计 · 精准搜索',
    feature1: {
      title: '分词统计',
      content: '快速统计多个 Word、TXT 文件词频，支持智能分词和结果导出，让您轻松掌握文档中的核心词汇分布。'
    },
    feature2: {
      title: '精准搜索统计',
      content: '提供关键词精准搜索功能，支持大小写区分和全词匹配模式，帮助您快速定位并统计特定词汇的出现次数。'
    },
    feature3: {
      title: '广泛应用场景',
      content: '适用于学术研究（分析文献关键词分布）、市场分析（统计热门词汇频次）、日常文档处理（快速了解文档核心内容）等多种场景。'
    }
  },

  // API教程
  apiTutorial: {
    pageTitle: 'API教程',
    pageSubtitle: '自定义配置大语言模型需要填写三个核心参数：接口地址（Base URL）、模型名称（Model Name）、API Key；自定义机器引擎需要填写的二个核心参数，接口地址（Base URL）、API Key。',
    triggerButton: 'API教程',
    openPanel: '打开API教程面板',
    closePanel: '关闭教程面板',
    closePanelBtn: '关闭面板',
    panelTitle: 'API Key 申请教程',
    panelSubtitle: '快速获取各大AI平台API密钥',
    emptyTitle: '暂无教程内容',
    emptyDesc: '该厂商的API申请教程正在准备中...',
    scrollTop: '回到顶部',
    imageAlt: '教程图片放大查看',
    // 智普AI
    zhipu: {
      step1: {
        title: '1. 注册账号',
        content: '访问智普AI开放平台 https://open.bigmodel.cn，使用手机号或邮箱完成账号注册和实名认证。'
      },
      step2: {
        title: '2. 找到API管理页面',
        content: '登录后进入控制台，在右上角找到"API Key"进入API配置页面。'
      },
      step3: {
        title: '3. 创建API Key',
        content: '在API管理页面点击"创建API Key"按钮，输入名称并设置权限，生成后复制保存API Key。'
      }
    },
    // DeepSeek
    deepseek: {
      step1: {
        title: '1. 访问官网登录账号',
        content: '打开 DeepSeek 官方网站 https://platform.deepseek.com，点击右上角的"登录/注册"按钮，使用邮箱或手机号完成注册并登录。'
      },
      step2: {
        title: '2. 进入API Keys管理',
        content: '登录后点击左侧的"API keys"选项卡。'
      },
      step3: {
        title: '3. 创建并保存API Key',
        content: '点击"创建新的API Key"按钮，输入名称并确认，复制生成的API Key（API Key只显示一次）'
      }
    },
    // Kimi
    kimi: {
      step1: {
        title: '1. 访问 Moonshot AI 官网',
        content: '打开 Moonshot AI 官网 https://platform.moonshot.cn，点击"立即体验"或"登录"。'
      },
      step2: {
        title: '2. 注册并登录账号',
        content: '使用手机号或邮箱注册账号，完成验证后登录。'
      },
      step3: {
        title: '3. 进入API管理',
        content: '登录后在个人中心或控制台中找到"API Keys"选项。'
      },
      step4: {
        title: '4. 获取API Key',
        content: '点击"创建API Key"，设置名称和权限，生成后复制保存。'
      }
    },
    // 硅基流动
    siliconflow: {
      step1: {
        title: '1. 访问硅基流动官网',
        content: '打开 https://siliconflow.cn，点击"立即体验"进入注册页面。'
      },
      step2: {
        title: '2. 注册账号',
        content: '使用手机号注册，接收验证码完成注册流程。'
      },
      step3: {
        title: '3. 进入控制台',
        content: '登录后进入控制台，点击左侧菜单"API 密钥"。'
      },
      step4: {
        title: '4. 创建API Key',
        content: '点击"新建API Key"，输入名称和用途描述，生成API Key。'
      }
    },
    // 302.ai
    ai302: {
      step1: {
        title: '1. 访问 302.ai 官网',
        content: '打开 https://302.ai，点击"登录"或"注册"按钮。（可调用国外模型）'
      },
      step2: {
        title: '2. 进入管理后台',
        content: '点击菜单栏的"管理后台"。'
      },
      step3: {
        title: '3. 购买额度并进入API Key',
        content: '根据需要购买API调用额度，并点击左侧"API key"。'
      },
      step4: {
        title: '4. 生成API Key',
        content: '生成API Key并配置权限。'
      }
    },
    // 小牛翻译
    niutrans: {
      step1: {
        title: '1. 访问小牛翻译官网',
        content: '打开小牛翻译官网 https://niutrans.com，点击右上角的"登录/注册"按钮。'
      },
      step2: {
        title: '2. 注册账号',
        content: '使用手机号或邮箱注册账号，完成验证后登录。'
      },
      step3: {
        title: '3. 进入控制台',
        content: '登录后进入"小牛智能云"控制台，在产品管理中找到翻译服务。'
      },
      step4: {
        title: '4. 获取API Key',
        content: '在API管理页面点击"创建API Key"，设置名称和权限，生成后复制保存API Key。'
      }
    },
    // 腾讯云翻译
    tencent: {
      step1: {
        title: '1. 访问腾讯云官网',
        content: '打开腾讯云官网 https://cloud.tencent.com，点击"免费注册"完成账号注册。'
      },
      step2: {
        title: '2. 实名认证',
        content: '登录后进入控制台，完成实名认证（需要上传身份证或进行人脸识别）。'
      },
      step3: {
        title: '3. 开通机器翻译服务',
        content: '在产品搜索中搜索"机器翻译"，进入服务页面并开通服务。'
      },
      step4: {
        title: '4. 获取访问密钥',
        content: '进入"访问管理 > API密钥管理"页面，点击"新建密钥"获取SecretId和SecretKey。'
      }
    }
  },

  // 动图标题 - 翻译工具
  animations: {
    translationTool: {
      sentenceSwitch: '句子切分与段落切分无缝切换',
      machineTranslation: '机器翻译全文',
      llmTranslation: 'AI翻译全文',
      llmPolish: 'AI润色全文',
      llmReview: 'AI审校全文',
      llmTerminologyExtract: 'AI提取全文术语',
      llmSummary: 'AI总结全文',
      llmMindmap: 'AI创建思维导图',
      llmTerminologyChat: 'AI引用聊天',
      bilingualExportSide: '左右对照导出',
      bilingualExportStack: '上下对照导出',
      dictionary: '词典功能',
      notes: '笔记功能',
      terminologyDb: '术语库'
    },
    terminologyTool: {
      toolInterface: '工具界面',
      terminologyExtract: '术语提取',
      terminologyTest: '自测模式',
      terminologyExport: '术语导出'
    },
    wordCountTool: {
      importDocuments: '导入文档或文件夹',
      batchProcessing: '批量处理',
      statisticsDisplay: '标签页展示各语言统计结果',
      exportExcel: '导出Excel，数据清晰，格式美观'
    },
    wordFrequencyTool: {
      importFiles: '导入文件',
      wordSegmentation: '分词统计',
      keywordSearch: '关键词搜索',
      exportResults: '导出结果'
    },
    corpusAlignmentTool: {
      fileImport: '文档导入',
      clipboardImport: '剪贴板导入',
      autoAlignment: 'AI智能对齐',
      exportFormats: 'Excel导出'
    }
  },

  // 术语库工具
  terminologyTool: {
    title: '术语库工具',
    subtitle: '高效整理 · 智能自测 · 简单易用',
    feature1: {
      title: '解决痛点',
      content: '在阅读双语对照文本时，我们常常会采用高亮标注的方式来辅助理解。然而，这种方法虽然方便阅读，却不便于将标注的内容整理到一个文档中。'
    },
    feature2: {
      title: '快速创建术语库',
      content: '为了解决这一痛点，元译科技开发了一款全新的程序。用户只需简单地拖选文档中的文本，按下 [Ctrl+C] 复制，然后点击程序中的"添加为原文"或"添加为译文"按钮，即可轻松创建术语库。'
    },
    feature3: {
      title: '导出功能',
      content: '该程序还支持将术语库导出为格式美观的 Excel 文档，极大地提升了整理和管理双语文本的效率。'
    },
    feature4: {
      title: '自测功能',
      content: '本程序提供"自测"功能。在该模式下，程序将从术语库中随机抽取术语，用户可以根据原文输入对应的译文，程序会自动进行匹配并判断翻译是否准确。'
    }
  },

  // 语料对齐工具
  corpusAlignmentTool: {
    title: '语料对齐工具',
    subtitle: 'AI驱动 · 智能对齐 · 多模型兼容',
    feature1: {
      title: '多种导入方式，灵活便捷',
      content: '支持单文档导入、双文档导入、剪贴板导入等多种方式，兼容不同用户的使用习惯，让语料对齐更加灵活便捷。'
    },
    feature2: {
      title: 'AI智能驱动，支持多种模型格式',
      content: '支持云端大语言模型（兼容OpenAI格式）和本地部署模型（兼容Ollama格式），断网可用，适合涉密单位数据安全。AI算法精准识别双语对应关系，大幅提升对齐效率。'
    },
    feature3: {
      title: 'Excel导出功能',
      content: '支持导出Excel格式，满足不同场景的使用需求。'
    },
    feature4: {
      title: '多语言对齐支持',
      content: '支持多种语言对齐，大语言模型支持什么语言就支持什么语言对齐。无论是中英、中日、英法，还是其他任意语言组合，只要您使用的大语言模型能够理解这些语言，就能实现精准的语料对齐。'
    }
  },
}
